export default "__VITE_ASSET__a9497805__"